import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { useEffect, useRef, useState } from 'react'
import Attachment from '../Attachment/Attachment'
import { Color, LuxIconBadge } from '@lux/wardrobe-lib'
import { layoutActions } from '@Techedge/digitalportal-shared'
import DialogSpiltFile from '../Dialogs/DialogSplitFile/DialogSpiltFile'
import { newActivityCreationError } from '@/app/redux/actions/activity-creation'
import { ProjectsService, UploadFileType } from '@/app/services/ProjectsService'
import './AddAttachment.scss'

const AddAttachment = (props: any) => {
    const {
        id,
        form,
        onRemove,
        disabled,
        setLoading,
        showSplitFile,
        customEndpoint,
        messageEndpoint,
        showRemoveIcon,
        newActivityCreationError,
    } = props

    const intl = useIntl()

    const inputRef = useRef(null)

    const componentClass = 'smart-modals-add-attachment'

    const [files, setFiles] = useState(null)

    const [showSplitDialog, setShowSplitDialog] = useState(false)

    const handlerSave = (files, type, i= 0, filesUploaded= []) => {
            const file = files[i]
            const reader = new FileReader()
            reader.onload = function (evt) {
                setLoading(true)
                ProjectsService.UploadFile(
                    evt.target.result,
                    type,
                    file.name,
                    file.type,
                    customEndpoint,
                    messageEndpoint
                )
                    .then(async (res) => {
                        filesUploaded.push({ file, id: res.data.id, url: res.data.url })
                        if (files.length > i + 1) {
                            handlerSave(files, type, i + 1, filesUploaded)
                        } else {
                            setLoading(false);
                            props.onUpload(filesUploaded)
                        }
                    })
                    .catch((e) => {
                        setLoading(false)
                        inputRef.current.value = null
                        const message = e.response?.data?.message || e.message
                        newActivityCreationError(message)
                    })
            }
            reader.readAsDataURL(file)
    }

    const hasXLSXfile = (files: FileList): boolean => {
        let hasXLSXfile: boolean = false
        if (!!files && files.length) {
            for (let i = 0; i < files.length; i++) {
                if (files[i].type ===
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    hasXLSXfile = true
                    break;
                }
            }
            return hasXLSXfile
        }
        return hasXLSXfile
    }

    const onUpload = (e) => {
        if (
            (!showSplitFile && showSplitFile !== undefined)  &&
            (!!e.target.files && e.target.files.length > 0)
        ) {
            handlerSave(e.target.files, UploadFileType.FILE)
            return
        }

        setFiles(e.target.files)

        if (!!e.target.files && e.target.files.length > 0) {
            const hasXLSX = hasXLSXfile(e.target.files);
            if (!hasXLSX && e.target.files.length > 0) {
                handlerSave(e.target.files, UploadFileType.FILE)
                return
            }
            if (hasXLSX && e.target.files.length > 1) {
                inputRef.current.value = null;
                const message = intl.formatMessage({
                    id: 'modals.new.activity.section.main.info.attachment.xlsx.denied',
                    defaultMessage: 'No XLSX files allowed for multiple upload',
                })
                newActivityCreationError(message)
                return
            }
            setShowSplitDialog(true)
        }
    }

    const onSplit = (splitValue) => {
        setShowSplitDialog(false)
        handlerSave(files, splitValue)
    }

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__attachment-list`}>
                {form?.attachmentList?.value?.map((item, index) => {
                    return (
                        <div className={`${componentClass}__item-container`} key={index}>
                            <Attachment
                                showDownloadIcon={true}
                                fileBlob={item?.fileBlob}
                                hideEyeIcon={item?.hideEyeIcon}
                                showRemoveIcon={showRemoveIcon}
                                fileUrl={item?.url || item?.fileUrl}
                                fileName={item?.file?.name || item?.fileName}
                                fileExtension={
                                    item?.file?.ext ||
                                    item?.file?.name?.split('.').pop() ||
                                    item?.ext ||
                                    item?.fileExtension
                                }
                                onRemove={() => {
                                    inputRef.current.value = null
                                    onRemove(item?.file || item)
                                }}
                            />
                        </div>
                    )
                })}
            </div>
            <div className={`${componentClass}__attachment-button-container`}>
                <div
                    className={`${componentClass}__attachment-button ${
                        disabled ? 'disabled' : ''
                    }`}>
                    <label className={`${componentClass}__title`} htmlFor={id || 'attachment'}>
                        <LuxIconBadge
                            icon="plus"
                            color={disabled ? Color.GREY2 : Color.BLUE}
                            backgroundColor={disabled ? Color.GREY4 : Color.BG_GREY}
                        />
                        <span className="link-mini">
                            {intl.formatMessage({
                                id: 'modals.new.activity.section.main.info.add.attachment',
                                defaultMessage: 'Add attachment',
                            })}
                        </span>
                    </label>
                    <input
                        ref={inputRef}
                        type="file"
                        multiple={true}
                        id={id || 'attachment'}
                        style={{ display: 'none' }}
                        onChange={onUpload}
                        disabled={disabled}
                    />
                </div>
            </div>
            <DialogSpiltFile
                dialogVisible={showSplitDialog}
                onSave={onSplit}
                onHide={() => {
                    inputRef.current.value = null
                    setShowSplitDialog(false)
                }}
            />
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({
    setLoading: (loading) => dispatch(layoutActions.setModals({ props: { loading } })),
    newActivityCreationError: (err) => dispatch(newActivityCreationError(err)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddAttachment)
